<template>
  <div>
    <div class="top">
      <div class="main-width py-5">
        <VBreadcrumb
          :options="[{ label: '首页', to: '/' }, { label: '邮轮公司' }]"
        ></VBreadcrumb>
      </div>
      <section class="main-width" v-if="adStore.state && adStore.state.length">
        <swiper :options="swiperOptions" class="mySwiper">
          <swiper-slide v-for="(item, index) in adStore.state" :key="index">
            <a
              class="block h-full"
              :href="item.url"
              :title="item.title"
              :target="item.target"
            >
              <img class="swiper-img" :alt="item.title" :src="item.path_url" />
            </a>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination" />
        </swiper>
      </section>
    </div>
    <section class="box">
      <div class="main-width">
        <ScrollNav class="mb-3 sticky bg-white z-10" :style="{top: `${stickyOffsetTop}px`}" :options="navs" :offset="scrollToOffset" />
        <!-- <template> -->
        <div
          v-for="item in brands"
          :id="genSectionId(item.id)"
          class="collapse"
        >
          <div class="item">
            <div class="route-name">
              {{ item.name }} <img class="logo" :src="item.logo" />
            </div>
            <nuxt-link
              class="status"
              :to="`/company/${item.id}`"
              target="_blank"
            >
              公司详细介绍
              <span class="arrow">
                <i class="ficon ficon-jiantouarrow5941"></i>
              </span>
            </nuxt-link>
          </div>
          <div class="content">
            <product-collection
              @more="moreProduct"
              :collection="item.list"
            ></product-collection>
          </div>
        </div>
        <!-- </template> -->
      </div>
    </section>
    <div class="link-box">
      <nuxt-link class="link-btn" target="_blank" to="/company/list"
        >查看其他邮轮公司</nuxt-link
      >
    </div>
    <AppDock />
  </div>
</template>
<script>
import {
  defineComponent,
  useMeta,
  ref,
  useFetch,
  computed,
} from "@nuxtjs/composition-api";
import { getCompanyAndProduct } from "@/services/company";
import VBreadcrumb from "@/components/VBreadcrumb.vue";
import ProductCollection from "@/components/Product-collection.vue";
import usePlatformAdvertBanner from "~/composables/usePlatformAdvertBanner";
import AppDock from '~/components/layouts/AppDock.vue'
import { useAsyncState } from "@vueuse/core";
import useLayout from "~/composables/useLayout";
import { REQUEST_CODES } from "~/constants/const-http";

import ScrollNav from "~/components/ScrollNav.vue";
export default defineComponent({
  name: "cruise-company",
  auth: false,
  head: {},
  layout: "Main",
  setup() {
    useMeta({
        title: "邮轮公司,邮轮品牌,游轮品牌,游轮公司,邮轮品牌查询,上船吧邮轮平台",
        meta: [
            {
            name: "description",
            content:
                "上船吧邮轮平台为您提供全球邮轮品牌,邮轮公司查询服务,邮轮公司包括世纪游轮,皇家加勒比邮轮,招商维京游轮,诺唯真邮轮,公主邮轮,庞洛邮轮,地中海邮轮,东方皇家旅游船公司,迪士尼邮轮,歌诗达邮轮,嘉年华邮轮,南极21世纪探险,南海邮轮,长江黄金系列游轮,长江海外游轮,重庆大美游轮,中船嘉年华邮轮,银海邮轮,维多利亚游轮,上海蓝梦国际,名人邮轮,丽思卡尔顿游艇等,邮轮类型包括长江河轮,境外河轮,海洋邮轮,极地邮轮,海洋帆船,渡轮,游艇等",
            hid: "description",
            },
            {
            name: "keywords",
            hid: "keywords",
            content: "邮轮品牌查询,邮轮公司,邮轮品牌,游轮品牌,游轮公司,邮轮品牌查询",
            },
        ],
    });
    const adStore = ref(usePlatformAdvertBanner(44));

    const { state, execute } = useAsyncState(
      async () => {
        const { msg, data, code } = await getCompanyAndProduct();
        if (code !== REQUEST_CODES.ERROR_OK) {
          throw new Error(msg);
        }
        return data;
      },
      [],
      {
        immediate: false,
        onError: (err) => console.error(err),
      }
    );
    useFetch(async () => {
      await execute(0);
    });
    const genSectionId = (id) => `section-${id}`;

    const { headerSize } = useLayout();
    const scrollToOffset = computed(() => headerSize.height + 50);
    const stickyOffsetTop = computed(() => headerSize.height);
    const brands = computed(() =>
      state.value.map((item) => {
        let routes = [];
        if (item.product && item.product.length) {
          routes.push({
            id: "-9999",
            name: "平台推荐",
            product: [...item.product],
          });
        }

        routes = routes.concat(item.list.filter((p) => p.product.length > 0));
        return {
          ...item,
          list: routes,
        };
      })
    );

    const navs = computed(() =>
      brands.value.map((item) => ({
        text: item.name,
        sectionSelector: `#${genSectionId(item.id)}`,
      }))
    );
    return {
      adStore,
      detail: state,
      navs,
      scrollToOffset,
      genSectionId,
      stickyOffsetTop,
      brands,
    };
  },
  data() {
    return {
      // detail: [],
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        autoplay: true,
        lazy: true,
        loop: true,
      },
    };
  },
  components: {
    VBreadcrumb,
    ScrollNav,
    ProductCollection,
    AppDock
  },
  methods: {
    getBrandId(id) {
      let result;
      for (let item of this.detail) {
        let cruiseList = item.list;
        if (cruiseList.some((cruise) => cruise.id === id)) {
          result = item.id;
          break;
        }
      }
      return result;
    },
    moreProduct(cruiseId) {
      // 带着邮轮公司跳转
      let brandId = this.getBrandId(cruiseId);
      console.log(brandId);

      const { href } = this.$router.resolve({
        path: "/product/automation/foreign-cruise-search",
        query: {
          route: "",
          cruise_route_first: "",
          cruise: cruiseId,
          brand: brandId,
          days: "",
          travel_date: "",
          year: "",
          city: "",
          country: "",
        },
      });
      window.open(href, "_blank");
    },
    formatData(item) {
      let arr = [];
      if (item.product && item.product.length) {
        //设置平台推荐
        arr.push({
          id: "-9999",
          name: "平台推荐",
          product: item.product,
        });
      }
      let route = item.list.filter((p) => p.product.length);
      arr = arr.concat(route);
      return arr;
    },
  },
  // async fetch() {
  //   const { msg, data, code } = await getCompanyAndProduct()
  //   if (code === 10000 || code === 200) {
  //     this.detail = data
  //     console.log(data)
  //   } else {
  //     this.$message({
  //       type: "error",
  //       text: msg
  //     });
  //   }
  // }
});
</script>
<style lang="scss" scoped>
.mySwiper {
  height: 240px;
  width: 100%;
  margin-bottom: 30px;
}
.mySwiper .swiper-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.box {
  background-color: #fff;
  padding-bottom: 30px;
}
.collapse {
  width: 100%;
}
.collapse .item {
  height: 60px;
  background-color: #f3f5f8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 18px 0 20px;
  margin-bottom: 10px;
  cursor: pointer;
}
.collapse .item .route-name {
  font-size: 24px;
  color: #3d3d3d;
  font-weight: 500;
  display: flex;
  align-items: center;
}
.collapse .item .logo {
  width: 94px;
  height: 32px;
  object-fit: cover;
  margin-left: 8px;
  display: inline-block;
  border-radius: 4px;
  border: 1px solid #979aa8;
}
.collapse .item .status {
  font-size: 16px;
  color: $color-black-2;
}
.collapse .item .status:hover {
  color: $color-primary;
}
.collapse .item .status .arrow {
  display: inline-block;
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.collapse .item .status .rotateUp {
  transform: rotate(180deg);
}
.collapse .item .status .rotateDown {
  transform: rotate(0deg);
}
.collapse .content {
  transition: all 0.4s;
  padding-top: 6px;
}
.link-box {
  padding: 50px 0;
  text-align: center;
}
.link-box .link-btn {
  border-radius: 0.25rem;
  display: inline-block;
  height: 2.75rem;
  line-height: 2.75rem;
  text-align: center;
  width: 12.5rem;
  border: 1px solid $color-black-2;
  font-size: 16px;
  color: $color-black-2;
}
.link-box .link-btn:hover {
  color: $color-primary;
  border-color: $color-primary;
}
</style>
